var map = {
	"./_borders.less": 73222,
	"./_colors.less": 86929,
	"./_commons.less": 55,
	"./_fonts.less": 76163,
	"./_imports.less": 61131,
	"./_mediaqueries.less": 78177,
	"./_mixins.less": 7399,
	"./_sizes.less": 33103,
	"./_utils.less": 69696,
	"./animations.less": 11185,
	"./app.less": 55331,
	"./button-tip.less": 93982,
	"./checkboxgroup.less": 37900,
	"./colums.less": 65695,
	"./commonPopup.less": 33605,
	"./components/componentAudio.less": 58142,
	"./components/componentDropzone.less": 68057,
	"./components/componentHotspot.less": 26099,
	"./components/componentImage.less": 68829,
	"./components/componentSettings.less": 27999,
	"./components/componentSpinner.less": 36549,
	"./components/componentSymbol.less": 81378,
	"./components/componentTable.less": 97912,
	"./components/componentText.less": 41865,
	"./components/componentTimer.less": 18221,
	"./components/componentTrafficlight.less": 12081,
	"./components/components.less": 33853,
	"./components/videocomponent.less": 53731,
	"./contentItemButton.less": 14110,
	"./contentType.less": 41789,
	"./contentTypes/dragQuestion.less": 96621,
	"./contentTypes/dragQuestionDefinitions.less": 23479,
	"./contentTypes/interactiveQuestionDefinitions.less": 66157,
	"./contentTypes/maps.less": 20408,
	"./contentTypes/openQuestion.less": 55555,
	"./contentTypes/openQuestionDefinitions.less": 4581,
	"./contentTypes/poll.less": 12394,
	"./contentTypes/pollDefinitions.less": 39478,
	"./contentTypes/question.less": 40739,
	"./contentTypes/questionDefinitions.less": 38341,
	"./contentTypes/site.less": 75196,
	"./contentTypes/slide-definitions.less": 79257,
	"./contentTypes/slide.less": 30070,
	"./contentTypes/weblink.less": 22553,
	"./contentTypes/wordweb.less": 51637,
	"./contentTypes/wordwebDefinitions.less": 89647,
	"./dragQuestionComponentStyles.less": 28123,
	"./elements.less": 2631,
	"./emoji.less": 77610,
	"./icons-mixin.less": 54086,
	"./icons.less": 40286,
	"./images-mixin.less": 34652,
	"./message.less": 52031,
	"./miniaudioplayer.less": 6506,
	"./player.less": 13095,
	"./playerPin.less": 50712,
	"./slideNoteShared.less": 39012,
	"./smallspinner.less": 32822,
	"./spacing.less": 38097,
	"./table.less": 76268,
	"./thumbPreview.less": 24430,
	"./toast.less": 48207,
	"./util.less": 4666,
	"./video.less": 17483,
	"./videocontroler.less": 75945,
	"./wobble.less": 14779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5159;